module.exports = __webpack_public_path__ + "static/media/examples_bach_846.945aad72.wav";